// ─────────────────────────────────────────────────────────────
//  HOW TO GET YOUR FIREBASE CONFIG:
//  1. Go to https://console.firebase.google.com
//  2. Click gear icon ⚙️ → Project settings
//  3. Scroll to "Your apps" → click "</>" (Add web app)
//  4. Register app name: finvault-web → Continue
//  5. Copy the firebaseConfig object below
// ─────────────────────────────────────────────────────────────

// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { logWarn } from "./utils/logger";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCjnpVR504Iq4dtLUjONaPBuN1JvpquV-Y",
  authDomain: "finvault-8ee00.firebaseapp.com",
  projectId: "finvault-8ee00",
  storageBucket: "finvault-8ee00.firebasestorage.app",
  messagingSenderId: "701646152371",
  appId: "1:701646152371:web:319ed730b785b5341546c6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Optional Firebase App Check
// ───────────────────────────
// Keep disabled until you create a Web reCAPTCHA/App Check key in Firebase Console.
// Add REACT_APP_FIREBASE_APPCHECK_SITE_KEY to .env.local, then rebuild/deploy.
// This protects Firebase resources from automated abuse without changing normal app UI.
export let appCheck = null;
const appCheckSiteKey = process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY;

if (typeof window !== "undefined" && appCheckSiteKey) {
  try {
    if (process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG === "true") {
      // Development only. Firebase will print a debug token in the browser console.
      window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
    }
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(appCheckSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (error) {
    // Do not block the app if App Check is not configured yet.
    logWarn("Firebase App Check was not initialized", error);
  }
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// NOTE: Firebase Storage is NOT used in this phase.
// Profile/receipt image upload is disabled for export-only safety.
